import React, { Component, Fragment } from "react";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import LookupItemsForm from "./LookupItems";
import { AppCard, createTabHeaderTemplate } from "../../components/ui";
import IndividualRiskMatrixForm from "./IndividualRiskMatrix";
import RiskExpressionsForm from "./RiskExpressions";
import AMLPrecisionForm from "./AMLPrecisionForm";

interface RiskSettingsProps {
    onHide: () => void;
}

interface RiskSettingDialogState {
    activeTabIndex: number;
}

export default class RiskSettingsModal extends Component<RiskSettingsProps, RiskSettingDialogState> {
    validationErrors: Map<string, boolean> = new Map<string, boolean>();
    countryNames: Map<string, string> = new Map<string, string>();

    constructor(props: RiskSettingsProps | Readonly<RiskSettingsProps>) {
        super(props);

        this.state = {
            activeTabIndex: 0,
        };
    }

    componentDidMount = async () => {
        // this.setState({ isLoading: true });
        // this.setState({ isLoading: false });
    };

    render() {
        return (
            <Dialog
                header="Risk Configuration"
                visible={true}
                style={{ width: "70vw" }}
                modal
                onHide={this.props.onHide}
                pt={{
                    content: {
                        className: "max-h-[80vh]",
                    },
                }}
            >
                <Fragment>
                    <AppCard className="!my-0">
                        {/* <AppCard.Header title="Risk Settings" /> */}
                        <AppCard.Body className="!p-0">
                            <TabView
                                activeIndex={this.state.activeTabIndex}
                                onTabChange={(e) => {
                                    this.setState({ activeTabIndex: e.index });
                                }}
                                pt={{
                                    nav: {
                                        className: "gap-1",
                                    },
                                }}
                            >
                                <TabPanel
                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                    header="Individual Risk Matrix"
                                >
                                    <IndividualRiskMatrixForm onHide={this.props.onHide} />
                                </TabPanel>
                                <TabPanel pt={{ content: { className: "pt-0 px-5 pb-5" } }} headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)} header="Risk Values">
                                    <LookupItemsForm onHide={this.props.onHide} />
                                </TabPanel>
                                <TabPanel pt={{ content: { className: "pt-0 px-5 pb-5" } }} headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)} header="Risk Expressions">
                                    <RiskExpressionsForm onHide={this.props.onHide} />
                                </TabPanel>
                                <TabPanel pt={{ content: { className: "pt-0 px-5 pb-5" } }} headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)} header="AML Precision">
                                    <AMLPrecisionForm onHide={this.props.onHide} />
                                </TabPanel>
                            </TabView>
                        </AppCard.Body>
                    </AppCard>
                </Fragment>
            </Dialog>
        );
    }
}
